module.exports = __webpack_public_path__ + "img/unique.b52701f9.svg";